import React from 'react';

import ArrowUp from 'assets/images/arrow-up.svg';

import BaseIcon from './BaseIcon';

const ArrowUpIcon = props => <BaseIcon {...props} src={ArrowUp} />;

export default ArrowUpIcon;
